angular.module('bbl.directives.join-zoom', []);

require('./join-zoom-meeting-cta');
require('./join-zoom-meeting-modal');



/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/dashboard/join-zoom/index.js
 ** module id = 334
 ** module chunks = 0
 **/